import React from 'react'
import {Link} from "react-router-dom";
import {BiCaretRight, BiHome, BiHomeAlt} from 'react-icons/bi';


import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Scrollbar, A11y, Autoplay} from 'swiper';


/*Description imports */
import './itemdesc.css'


/*carousel imports */
import './gallery.css'



  /*portfolio item imports */
  import './formerportfolio.css'
  import IMG1 from '../../assets/iphone1.gif'
  import IMG2 from '../../assets/iphone2.gif'
  import IMG3 from '../../assets/iphone3.gif'
  import IMG4 from '../../assets/cinnamon1.png'
  import IMG5 from '../../assets/cinnamon2.png'

/*footer imports */
import Footer from '../../components/footer/Footer.js'

const Item1 = () => {
    return (
      <div onLoad={()=>{window.scrollTo(0, 130);}}>

<section id='testimonials'>
      <div style={{display:"flex",justifyContent:"center",margin:"4rem"}}>
       <Link to={"/#portfolio"}><a href="#" className="btn btn-primary">Home</a></Link> 
     </div>
      
      <h5>Item 1</h5>
      <h2>3D Website Landing Page</h2>
     
   <Swiper className="gallery__container"
   //swiper js options
   modules={[ Pagination, Scrollbar, A11y,Autoplay]}
   
   autoplay={{
    delay: 3500,
    disableOnInteraction: true,
  }}
   scrollbar={{ draggable: true }}
   slidesPerView={1}
   spaceBetween={50}
   pagination={{clickable:true}}
   
   > 
   {/*1 */}
  
    
    <SwiperSlide className="gallery-testimonial">
    <article className="formerportfolio__item" >
     <div className="formerportfolio__item-image">
      <img src={isBrowser?IMG1:IMG1} alt="portfolio item 1" />
    </div>
    <h3>( I )</h3>
    <div className="formerportfolio__item-cta">
    <a href="https://github.com/Dagogo-Clinton-Uranta/iphone-threejs" className="btn">Project Code(Github)</a>
    <a href="https://iphone-threejs-delta.vercel.app/" className="btn btn-primary" target="_blank" rel="noreferrer">Live Webpage</a>
    </div>
   </article>
    </SwiperSlide>  
    


     {/*2 */}
     <SwiperSlide className="gallery-testimonial">
    <article className="formerportfolio__item" >
     <div className="formerportfolio__item-image">
      <img src={isBrowser?IMG2:IMG2} alt="portfolio item 1" />
    </div>
    <h3>(II)</h3>
    <div className="formerportfolio__item-cta">
    <a href="https://github.com/Dagogo-Clinton-Uranta/iphone-threejs" className="btn">Project Code(Github)</a>
    <a href="https://iphone-threejs-delta.vercel.app/" className="btn btn-primary" target="_blank" rel="noreferrer">Live Webpage</a>
    </div>
   </article>
    </SwiperSlide>

 {/*3 */}
 <SwiperSlide className="gallery-testimonial">
    <article className="formerportfolio__item" >
     <div className="formerportfolio__item-image">
      <img src={isBrowser?IMG3:IMG3} alt="portfolio item 1" />
    </div>
    <h3>(III)</h3>
    <div className="formerportfolio__item-cta">
    <a href="https://github.com/Dagogo-Clinton-Uranta/iphone-threejs" className="btn">Project Code(Github)</a>
    <a href="https://iphone-threejs-delta.vercel.app/" className="btn btn-primary" target="_blank" rel="noreferrer">Live Webpage</a>
    </div>
   </article>
    </SwiperSlide>


  </Swiper> 

    </section>

{/*END OF PROJECT DISPLAY SECTION */}


    <section id='services'>
    <h5>Iphone 3D Web Design </h5>
    <h2>Design Decisions</h2>

    <div className="container decisions__container ">
      <article className="service">
        <div className="service__head">
          <h3>Design Decisions Include :-</h3>
        </div>

        <ul className="service__list">
          <li>
            <BiCaretRight className='service__list-icon'/>
            <p>GSAP (Green Sock Animation Protocol) was used to slide in the iphone models to create a continuous effect. </p>
          </li>
          
          <li>
            <BiCaretRight className='service__list-icon'/>
            <p>To Create the slding video gallery, GSAP functions were triggered when the video event listeners were hit.</p>
          </li>
          
          <li>
            <BiCaretRight className='service__list-icon'/>
            <p>For the iPhone models they were extracted from a glb file,with a combination of meshes and materials applied to it.</p>
          </li>

          <li>
            <BiCaretRight className='service__list-icon'/>
            <p> For the scenery, a React library for Three JS, react-three-drei was used.Viewports, ambient light and perspective camera were imported.</p>
          </li> 

          
        
        </ul>
      </article>
     
    
  </div>     
    
    </section>

     {/*END OF  DESCRITPION SECTION*/}

    

    <section id='services'>
    <h5>Iphone 3D Web Design</h5>
    <h2>Technology Involved</h2>

    <div className="container decisions__container ">
      <article className="service">
        <div className="service__head">
          <h3>The rationale for technologies used :-</h3>
        </div>

        <ul className="service__list">
          <li>
            <BiCaretRight className='service__list-icon'/>
            <p>All images are SVG (scalable vector graphics) to maintain image quality.</p>
          </li>
          
          <li>
            <BiCaretRight className='service__list-icon'/>
            <p> React js was used, to easily replicate sections via component usage and for a single page load. </p>
          </li>
          
          <li>
            <BiCaretRight className='service__list-icon'/>
            <p>React's styled components are used here, to integrate react with a dynamic style of css and media queries.</p>
          </li>
          <li>
            <BiCaretRight className='service__list-icon'/>
            <p>A useState hook is used to determine the visibility of the sign in page.</p>
          </li>
         
         
        </ul>
      </article>
     
    
  </div>     
    
      <div style={{display:"flex",justifyContent:"center",margin:"4rem"}}>
       <Link to={"/#portfolio"}><a href="#" className="btn btn-primary">Home</a></Link> 
     </div>

    </section>

     {/*END OF  DESCRITPION SECTION*/}
      
    <Footer/>
      
      </div>
    )
  }
  
  export default Item1